import { Box, Heading, UnorderedList } from "@chakra-ui/react"
import React from "react"
import { useTranslation } from "react-i18next"
import { RemoteStoreService } from "./RemoteStoreTypes"
import StoreHourRow from "./StoreHourRow"

interface Props {
  storeService: RemoteStoreService
}

const StoreHours: React.FC<Props> = ({ storeService }) => {
  const { t } = useTranslation()
  const { name, storeServiceHours } = storeService

  return (
    <Box w="full" maxWidth="260px">
      <Heading as="h2" fontSize="lg">
        {t(`components.store.StoreHours.title.${name}`)}
      </Heading>
      <UnorderedList listStyleType="none" ml={0} mt={4} spacing={2}>
        <StoreHourRow day="monday" storeHours={storeServiceHours} />
        <StoreHourRow day="tuesday" storeHours={storeServiceHours} />
        <StoreHourRow day="wednesday" storeHours={storeServiceHours} />
        <StoreHourRow day="thursday" storeHours={storeServiceHours} />
        <StoreHourRow day="friday" storeHours={storeServiceHours} />
        <StoreHourRow day="saturday" storeHours={storeServiceHours} />
        <StoreHourRow day="sunday" storeHours={storeServiceHours} />
      </UnorderedList>
    </Box>
  )
}

export default StoreHours
